export enum CurrencyTypes {
	usd = 'USD',
	euro = 'EURO',
}
